import { additionalInfoPageInitialState } from "../state";

export const setAdditionalInfo = (
  state = additionalInfoPageInitialState,
  action
) => {
  switch (action.type) {
    case "additionalInfo/setAdditionalInfo":
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export const setCoveredAdvisorCertificate = (
  state = additionalInfoPageInitialState.coveredAdvisorCertificate,
  action
) => {
  switch (action.type) {
    case "additionalInfo/setCoveredAdvisorCertificate": {
      // Only update fields inside coveredAdvisorCertificate, not at the root
      if (action.payload.coveredAdvisorCertificate.discloseddata !== undefined) {
        return {
          ...state,
          coveredAdvisorCertificate: {
            ...state.coveredAdvisorCertificate,
            discloseddata: action.payload.coveredAdvisorCertificate.discloseddata,
          },
        };
      }
      if (action.payload.coveredAdvisorCertificate.legaladvice !== undefined) {
        return {
          ...state,
          coveredAdvisorCertificate: {
            ...state.coveredAdvisorCertificate,
            legaladvice: action.payload.coveredAdvisorCertificate.legaladvice,
          },
        };
      }
      if (action.payload.coveredAdvisorCertificate.retainedaccess !== undefined) {
        return {
          ...state,
          coveredAdvisorCertificate: {
            ...state.coveredAdvisorCertificate,
            retainedaccess: action.payload.coveredAdvisorCertificate.retainedaccess,
          },
        };
      }
      return state;
    }
    default:
      return state;
  }
};
